import React, { useEffect, useMemo, useState } from 'react';
import Dashboard from '../../components/Dashboard';
import MenuContainer from '../../components/custom-components/menu/MenuContainer';
import { PATHS } from '../../router/routes';
import { Box, Flex, Text, Textarea, useToast } from '@chakra-ui/react';
import ZaraButton from '../../components/custom-components/buttons/Button';
import { useApolloClient, useMutation, useQuery } from '@apollo/client';
import { useNavigate, useParams } from 'react-router-dom';
import CloseButton from '../../components/custom-components/buttons/CloseButton';
import { useError } from '../../error-provider/ErrorProvider';
import { ChangeInitialMessage } from '../../graphql/mutations/ChangeInitialMessage';
import { GetUserAgents } from '../../graphql/queries/GetUserAgents';

const Greetings = () => {
    const toast = useToast();
    const router = useNavigate();
    const { showError } = useError();

    const [greetings, setGreetings] = useState('');

    const { id } = useParams();

    const apolloClient = useApolloClient();

    const [onChangeGreetings] = useMutation(ChangeInitialMessage, {
        onError(error) {
            showError(undefined, error);
        },
    });

    const { data: userAgents } = useQuery(GetUserAgents, {
        onError(error) {
            showError(undefined, error);
        },
    });

    const { agentGreetings, agentName, agentId } = useMemo(() => {
        const currentAgent = userAgents?.getUserAgents?.agents?.find((agent) => agent.id === id);

        const agentGreetings = currentAgent?.initialMessage ?? '';
        const agentName = currentAgent?.name ?? '';
        const agentId = currentAgent?.id;

        return {
            agentGreetings,
            agentName,
            agentId,
        };
    }, [userAgents, id]);

    useEffect(() => {
        if (agentGreetings) {
            setGreetings(agentGreetings);
        }
    }, [agentGreetings]);

    async function onSubmit() {
        const variables = {
            initialMessage: greetings,
            agentId: agentId,
        };
        await onChangeGreetings({
            variables: variables,
            async onCompleted(data) {
                if (data.changeInitialMessage.__typename === 'SuccessType') {
                    toast({
                        title: data.changeInitialMessage.message,
                        status: 'success',
                        isClosable: true,
                    });

                    apolloClient.cache.modify({
                        id: `AgentType:${agentId}`,
                        fields: {
                            initialMessage() {
                                return greetings;
                            },
                        },
                    });
                    router(PATHS.MY_AGENT);
                }

                if (data.changeInitialMessage.__typename === 'ErrorType') {
                    toast({
                        title: data.changeInitialMessage.message,
                        status: 'error',
                        isClosable: true,
                    });
                }
            },
        });
    }
    return (
        <Dashboard title={PATHS.TRAINING_GUIDE}>
            <MenuContainer title={PATHS.TRAINING_GUIDE}>
                <Box p='0px 15px' w='100%' mt={{ base: '70px', sm: '110px' }}>
                    <Box pos='relative' borderRadius='12px' boxShadow='0px 10px 15px -3px #0000001A'>
                        <CloseButton isSignIn='true' path={PATHS.MY_AGENT} />
                        <Box p='16px 24px'>
                            <Text fontSize='16px' lineHeight='20px' fontWeight='700' color='#1A202C'>
                                Greeting for {agentName}
                            </Text>
                        </Box>
                        <Textarea
                            onChange={(e) => setGreetings(e.target.value)}
                            fontSize='16px'
                            lineHeight='20px'
                            fontWeight='400'
                            color='#718096'
                            border='none'
                            value={greetings}
                            css={{
                                '@media only screen and (max-width: 380px)': {
                                    minHeight: '420px',
                                },
                                '@media only screen and (min-width: 385px)': {
                                    minHeight: '600px',
                                },
                            }}
                            p='8px 24px'
                        />
                    </Box>
                    <Flex p='16px 24px' mb='100px' justifyContent='center' alignItems='center'>
                        <ZaraButton
                            onClick={(e) => {
                                e.stopPropagation();

                                router(PATHS.MY_AGENT);
                            }}
                            variant='secondary'
                            mr='10px'
                        >
                            Cancel
                        </ZaraButton>
                        <ZaraButton
                            onClick={(e) => {
                                e.stopPropagation();

                                onSubmit();
                            }}
                        >
                            Update
                        </ZaraButton>
                    </Flex>
                </Box>
            </MenuContainer>
        </Dashboard>
    );
};

export default Greetings;
